
export const lineIsStillInPlaceText    = 'Line Is Still In Place'
export const inconclusiveNoImageryText = 'Inconclusive - No Imagery'
export const inconclusiveText          = 'Inconclusive'
export const cutAwayText               = 'Line Has Been Cut Away From Network End'
export const oldBTSText                = 'Old Builders Supply'
export const undergroundText           = 'Line Underground'

export const lineStatusTextOrder = [
    lineIsStillInPlaceText,
    inconclusiveNoImageryText,
    inconclusiveText,
    cutAwayText,
    oldBTSText,
    undergroundText,
]